import MainContent from '@/layouts/MainContent';
import { Tabs } from 'antd';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import BaseTariffTab from './components/BaseTariffTab';
import BaseTicketClassTab from './components/BaseTicketClassTab';
import BusBrandTab from './components/BusBrandTab';

const PAGE_TITLE = 'goSettingsPage_Title';

export default function GlobalSettingsPage() {
  const { t } = useTranslation();

  return (
    <MainContent title={t(PAGE_TITLE)}>
      <Helmet title={t(PAGE_TITLE)} />
      <div className="ant-layout-content-body">
        <Tabs>
          <Tabs.TabPane tab={t('goSettingsPage_BaseTariff')} key={'base-tariff'}>
            <BaseTariffTab />
          </Tabs.TabPane>
          <Tabs.TabPane tab={t('goSettingsPage_BaseTicketClass')} key={'base-ticket-class'}>
            <BaseTicketClassTab />
          </Tabs.TabPane>
          <Tabs.TabPane tab={'Bus Brand'} key={'bus-brand'}>
            <BusBrandTab />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </MainContent>
  );
}
